import React, { SyntheticEvent, useContext, useEffect, useState } from "react";
import { NavLink, Navigate, useLocation } from "react-router-dom";
import { ApiResponse, callApi } from "../api/ApiUtilities";
import LoginError from "../components/login/LoginError";
import { SLinkContext } from "../state/context";

function ResetPasswordView() {
  const { state } = useContext(SLinkContext);
  const [submiting, setSubmiting] = useState(false);
  const [error, setError] = useState("");
  const [password1, setPassword1] = useState("");
  const [password2, setPassword2] = useState("");
  const [redirect, setRedirect] = useState(false);
  const [redirectInvalid, setRedirectInvalid] = useState(false);
  const [loading, setLoading] = useState(true);
  let location = useLocation();

  useEffect(() => {
    const params = location.pathname.split("/");
    var token1 = params[3];
    var token2 = params[4];

    callApi<boolean>("/api/auth/checktoken", "POST", { token1: token1, token2: token2 })
      .catch((error: Error) => {
        setError(`Error checking token is valid, please refresh your screen and try again (${error.message})`);
      })
      .then((res: ApiResponse<boolean> | void) => {
        if (res && res.data) {
          setLoading(false);
        } else {
          setError(`Password reset token is invalid.`);
          setLoading(false);
          setRedirectInvalid(true);
        }
      });
  });

  function onSubmit(event: SyntheticEvent) {
    setSubmiting(true);
    event.preventDefault();
    setError("");
    if (password1 && password1.length < 8) {
      setError("Password is too short, it must be at least 8 characters long");
      setSubmiting(false);
      return;
    }
    if (password1 !== password2) {
      setError("Passwords don't match. Please try again.");
      setSubmiting(false);
      return;
    }
    const params = location.pathname.split("/");
    var token1 = params[3];
    var token2 = params[4];

    callApi<boolean>("/api/auth/reset", "POST", { token1: token1, token2: token2, newPassword: password1 })
      .catch((error: Error) => {
        setError(`Error setting your new password, refresh your screen and try again (${error.message})`);
      })
      .then((res: ApiResponse<boolean> | void) => {
        if (res && res.data) {
          setRedirect(true);
        } else {
          setError("Password was not able to be reset");
        }
        setSubmiting(false);
      });
  }

  if (redirect) {
    return <Navigate to={encodeURI("/login?message=Success! You can now log in with your new password.")} />;
  }
  if (redirectInvalid) {
    return <Navigate to={encodeURI("/login?message=You have already created or reset your password, login below.")} />;
  }

  return (
    <div className="sl-auth">
      <div className="d-flex">
        <img className="mx-auto" src="/imgs/ADoM-logo-216-colour.png" width="132" height="75" alt="Anglican Diocese of Melbourne" />
      </div>
      <h1 className="sl-auth-title">Set your password</h1>
      <p className="sl-auth-subtitle">Choose a password of at least 8 characters, typed twice. You'll then be able to sign in with it.</p>

      <main className="sl-auth-card">
        {loading ? (
          <>
            <p className="text-center text-muted mb-0">Checking your reset link...</p>
            <LoginError error={error} />
          </>
        ) : (
          <form onSubmit={onSubmit}>
            <div className="form-floating mb-2">
              <input
                type="password"
                className="form-control"
                id="resetPassword1"
                placeholder="Password"
                autoComplete="new-password"
                value={password1}
                onChange={(e) => setPassword1(e.target.value)}
              />
              <label htmlFor="resetPassword1">New password</label>
            </div>
            <div className="form-floating mb-3">
              <input
                type="password"
                className="form-control"
                id="resetPassword2"
                placeholder="Password"
                autoComplete="new-password"
                value={password2}
                onChange={(e) => setPassword2(e.target.value)}
              />
              <label htmlFor="resetPassword2">Repeat new password</label>
            </div>

            <button disabled={submiting} className="w-100 btn btn-lg btn-primary" type="submit">
              {submiting ? "Please wait..." : "Set new password"}
            </button>

            <LoginError error={error} />

            <p className="mt-3 mb-0 text-center">
              <NavLink to="/login">Back to sign in</NavLink>
            </p>
          </form>
        )}
      </main>
    </div>
  );
}

export default ResetPasswordView;
